module.exports = __webpack_public_path__ + "images/emoji/trumpet.877ed196d493f64a3b48.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/trumpet.png
// module id = qGen
// module chunks = 24